export enum TransformToolEnum {
  TRANSLATE = 'translate',
  ROTATE = 'rotate',
}
